import Phaser from "phaser";
import { GAMEPLAY } from "../config";
import type { SessionConfig } from "../types";

/**
 * View 13 — Tutorial Run (ui-sketches §13).
 *
 * Implemented as a thin delegate to RunnerScene: same scene logic, just
 * scoped to GAMEPLAY.tutorialDurationSec and tagged "TUTORIAL" in the HUD.
 * Telemetry from these 60 seconds is captured but excluded from the study
 * data window per PRD §10.
 */
export class TutorialScene extends Phaser.Scene {
  constructor() {
    super("tutorial");
  }

  create(): void {
    const cfg = this.scene.settings.data as SessionConfig | undefined;
    if (!cfg) {
      console.warn("TutorialScene: no SessionConfig in scene data; bouncing to launcher");
      this.scene.start("launcher");
      return;
    }
    this.scene.start("runner", {
      ...cfg,
      tutorial: true,
      durationSec: GAMEPLAY.tutorialDurationSec,
    });
  }
}
